import {connect} from 'react-redux';
import {ReactNode, Component, TouchEventHandler} from 'react';
import Snackbar from "material-ui/Snackbar";
import {IceClientStatus, LogoutReason} from "@neolab/ice-client";

import {
  Text, TranslationProvider, Translation,
} from "src/components/translation";
import {RootState} from "src/reducers";

import {retryConnectionClicked} from "./ConnectionBar.actions";

const strings = require<Translation>('./ConnectionBar.strings.yaml');


const AUTO_HIDE_DURATION = 3000;


type RetryMessageProps = {
  reconnectAt: number;
};

class RetryMessage extends Component<RetryMessageProps, {
  remainingSeconds: number | null;
}> {
  state = {
    remainingSeconds: null,
  };

  private intervalId: number | null;

  private clearInterval() {
    if (this.intervalId != null) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  private setReconnect(reconnectAt: number) {
    this.clearInterval();

    this.updateRemaining(reconnectAt);

    this.intervalId = setInterval(() => {
      this.updateRemaining(reconnectAt);
    }, 1000);
  }

  private updateRemaining(reconnectAt: number) {
    const remainingSeconds =
      Math.max(0, Math.ceil(reconnectAt - Date.now() / 1000));

    this.setState({remainingSeconds});

    if (remainingSeconds <= 0)
      this.clearInterval();
  }

  componentDidMount() {
    this.setReconnect(this.props.reconnectAt);
  }

  componentWillReceiveProps(props: RetryMessageProps) {
    this.setReconnect(props.reconnectAt);
  }

  componentWillUnmount() {
    this.clearInterval();
  }

  render() {
    return <span>
      <Text>Connection lost</Text>.
      {this.state.remainingSeconds != null && <span>
        {' '}
        <Text>Retrying in</Text>
        {' '}
        {this.state.remainingSeconds}
        {' '}
        <Text>second(s)</Text>...
      </span>}
    </span>;
  }
}

type ConnectionBarProps = {
  status: IceClientStatus;
  logoutReason: LogoutReason;
  reconnectAt: number | null;
  onRetryClick(): any;
};

type ConnectionBarState = {
  open: boolean;
  message: ReactNode;
  autoHideDuration?: number;
  action: ReactNode,
  onActionTouchTap: TouchEventHandler<any>;
};

class ConnectionBar extends Component<ConnectionBarProps, ConnectionBarState> {
  defaultState: ConnectionBarState = {
    open: false,
    message: '',
    autoHideDuration: undefined,
    action: '',
    onActionTouchTap() {},
  };

  state = this.defaultState;

  componentWillReceiveProps(props: ConnectionBarProps) {
    const {status, logoutReason, reconnectAt} = props;

    if (status === 'reconnecting') {
      if (reconnectAt == null) {
        this.setState({
          ...this.defaultState,
          open: true,
          message: <span><Text>Connecting</Text>...</span>,
        });
      } else {
        this.setState({
          ...this.defaultState,
          open: true,
          message: <RetryMessage reconnectAt={reconnectAt}/>,
          action: <Text>retry</Text>,
          onActionTouchTap: this.props.onRetryClick,
        });
      }
    } else if (status === 'logged-in' &&
               this.props.status === 'reconnecting') {
      this.setState({
        ...this.defaultState,
        open: true,
        message: <Text>Connection established</Text>,
        autoHideDuration: AUTO_HIDE_DURATION,
      });
    } else if (status === 'logged-out' && logoutReason === 'expired') {
      this.setState({
        ...this.defaultState,
        open: true,
        message: <Text>Session expired</Text>,
        autoHideDuration: AUTO_HIDE_DURATION,
      });
    }
  }

  private onRequestClose = (reason: string) => {
    if (reason !== 'clickaway')
      this.setState(this.defaultState);
  }

  render() {
    return <TranslationProvider translation={strings}>
      <Snackbar {...this.state} onRequestClose={this.onRequestClose}/>
    </TranslationProvider>;
  }
}


export default connect(
  (state: RootState) => {
    const {status, logoutReason, reconnectAt} = state.iceClient;

    return {status, logoutReason, reconnectAt};
  },
  {
    onRetryClick() {
      return retryConnectionClicked();
    },
  },
)(ConnectionBar);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/ConnectionBar.tsx